import robPermissions from './robPermissions'
import userRoles from './userRoles'

/**
 * Maps each ROB role to its allowed permissions.
 * This is the single source of truth for role-based access in the ROB module.
 * When business rules change, only this file needs to be updated.
 */
const robRolePermissions = {
  // Surveyor — full access to all sections except editing laboratory data, can submit survey
  [userRoles.SURVEYOR]: [
    robPermissions.VIEW_GENERAL,
    robPermissions.EDIT_GENERAL,
    robPermissions.VIEW_SEALS,
    robPermissions.EDIT_SEALS,
    robPermissions.VIEW_SOUNDING,
    robPermissions.EDIT_SOUNDING,
    robPermissions.VIEW_FUEL_SLUDGE_BILGE,
    robPermissions.EDIT_FUEL_SLUDGE_BILGE,
    robPermissions.VIEW_BUNKER,
    robPermissions.EDIT_BUNKER_INFO,
    robPermissions.EDIT_BARGE_TANK,
    robPermissions.VIEW_LABORATORY,
    robPermissions.VIEW_FUEL_TANKS,
    robPermissions.EDIT_FUEL_TANKS,
    robPermissions.VIEW_SLUDGE_OIL_BILGE,
    robPermissions.EDIT_SLUDGE_OIL_BILGE,
    robPermissions.SUBMIT_SURVEY,
  ],

  // Lab — view all, edit only laboratory data
  [userRoles.LAB]: [
    robPermissions.VIEW_GENERAL,
    robPermissions.VIEW_SEALS,
    robPermissions.VIEW_SOUNDING,
    robPermissions.VIEW_FUEL_SLUDGE_BILGE,
    robPermissions.VIEW_BUNKER,
    robPermissions.VIEW_LABORATORY,
    robPermissions.EDIT_LABORATORY,
    robPermissions.VIEW_FUEL_TANKS,
    robPermissions.VIEW_SLUDGE_OIL_BILGE,
  ],

  // GFP — view all, edit all, can approve survey
  [userRoles.GFP]: [
    robPermissions.VIEW_GENERAL,
    robPermissions.EDIT_GENERAL,
    robPermissions.VIEW_SEALS,
    robPermissions.EDIT_SEALS,
    robPermissions.VIEW_SOUNDING,
    robPermissions.EDIT_SOUNDING,
    robPermissions.VIEW_FUEL_SLUDGE_BILGE,
    robPermissions.EDIT_FUEL_SLUDGE_BILGE,
    robPermissions.VIEW_BUNKER,
    robPermissions.EDIT_BUNKER_INFO,
    robPermissions.EDIT_BARGE_TANK,
    robPermissions.VIEW_LABORATORY,
    robPermissions.EDIT_LABORATORY,
    robPermissions.VIEW_FUEL_TANKS,
    robPermissions.EDIT_FUEL_TANKS,
    robPermissions.VIEW_SLUDGE_OIL_BILGE,
    robPermissions.EDIT_SLUDGE_OIL_BILGE,
    robPermissions.APPROVE_SURVEY,
  ],
}

export default robRolePermissions
